module.exports = __webpack_public_path__ + "static/img/5.dabd787.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/3/zh/5.png
// module id = LQ7N
// module chunks = 0